import { Routes } from '@/router';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardsAchievementsHeader',
})
export default class CmgRewardsAchievementsHeader extends Vue {
  get extrasIconUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionExtras.default;
  }

  get placeholderBadgeUrl(): string {
    return this.$appStore.state.cms.images.icons.extrasBadgePlaceholder.default;
  }

  get totalExtraPoints(): number {
    return this.$appStore.state.reward.totalExtraPoints;
  }

  get chevronLeftUrl(): string {
    return this.$appStore.state.cms.images.icons.chevronLeft.default;
  }

  get isDesktop(): boolean {
    return this.$services.ui.isDesktop();
  }

  onClickBack() {
    this.$router.push({ name: Routes.RewardsExtras });
  }
}
